import { useForBinding } from '@practium/features/forBinding';
import { usePermissions } from '@practium/features/permissions';
import { CorrectionAdvicePage } from '@practium/features/recommendations';
import { LoadingState, useToast } from '@practium/ui';
import { Navigate, useNavigate, useSearchParams } from 'react-router-dom';
import { getRecommendationsListPath } from '../routes';
import {
	useDeleteAdviceCorrection,
	useGetAdviceCorrectionById,
} from '@practium/features/api';

export const EditCorrectionAdvicePageClient = () => {
	const toast = useToast();
	const navigate = useNavigate();
	const [searchParams] = useSearchParams();
	const id = searchParams.get('id') || '';
	const { isForBinding } = useForBinding();
	const { abilities } = usePermissions();
	const subject = isForBinding ? 'farmers-recommendations' : 'recommendations';
	const { data: advice, isLoading } = useGetAdviceCorrectionById(id);
	const { mutateAsync: deleteCorrectionAdvice } = useDeleteAdviceCorrection();

	const canEdit = abilities.can('update', subject);

	const canDelete = abilities.can('delete', subject);

	if (!canEdit) return <Navigate to="/recomendacoes" replace />;
	if (!advice || isLoading) return <LoadingState />;

	const handleDelete = async () => {
		try {
			await deleteCorrectionAdvice(id);
			navigate(getRecommendationsListPath('correction'));
		} catch (error: any) {
			toast.error(error.message);
		}
	};

	return (
		<CorrectionAdvicePage
			initialMode="edit"
			adviceId={id}
			viewData={advice}
			onBack={() => navigate(getRecommendationsListPath('correction'))}
			onDelete={canDelete ? handleDelete : undefined}
		/>
	);
};
